// ProductivityProjectDropdown.jsx
import React from "react";

const ProductivityProjectDropdown = ({ title, options, selectedProject, setSelectedProject }) => {
    return (
        <div>
            <h4 className="color-third mb-10">{title}</h4>
            <div className="display-flex gap-20 flex-direction-column flexwrap-wrap">
                <select
                    className="button-third"
                    value={selectedProject}
                    onChange={(e) => setSelectedProject(e.target.value)}
                >
                    <option value="">Sélectionner...</option>
                    {options.map(({ value, label }) => (
                        <option key={value} value={value}>
                            {label}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    );
};

export default ProductivityProjectDropdown;
